<!-- Linha 1: breadcrumb, título, subtexto, ações -->
<app-page-header
  [title]="title()"
  [subtitle]="subtitle()"
  [titleLarge]="true"
  [breadcrumbs]="breadcrumbs()"
>
  <ng-content select="[headerActions]"></ng-content>
</app-page-header>

<!-- Linha 2: tabs + Agrupar por + filtros -->
<div class="flex flex-col gap-2 mb-3">
  <div class="flex items-center gap-4 flex-wrap">
    <app-list-view-tabs [tabs]="tabs()" (selectTab)="onTabSelect($event)"></app-list-view-tabs>
  </div>
  <div class="flex flex-wrap items-center gap-2">
    <span class="text-sm text-[var(--muted)] mr-1">{{ 'listHeader.groupBy' | t }}</span>
    <span class="text-sm font-medium text-[var(--text)]">{{ 'listHeader.status' | t }}</span>
    <div class="flex items-center gap-1.5 ml-4">
      <button
        type="button"
        class="h-8 px-2.5 rounded-[var(--r-sm)] text-xs font-medium text-[var(--muted)] bg-[var(--bg-surface)] border border-[var(--border)] hover:bg-[var(--hover)]"
      >
        {{ 'listHeader.assignee' | t }}
      </button>
      <button
        type="button"
        class="h-8 px-2.5 rounded-[var(--r-sm)] text-xs font-medium text-[var(--muted)] bg-[var(--bg-surface)] border border-[var(--border)] hover:bg-[var(--hover)]"
      >
        {{ 'listHeader.priority' | t }}
      </button>
      <button
        type="button"
        class="h-8 px-2.5 rounded-[var(--r-sm)] text-xs font-medium text-[var(--muted)] bg-[var(--bg-surface)] border border-[var(--border)] hover:bg-[var(--hover)]"
      >
        {{ 'listHeader.overdue' | t }}
      </button>
    </div>
  </div>
</div>

<!-- Linha 3: status bar (chips) -->
<div class="mb-4">
  <ng-content select="[statusBar]"></ng-content>
</div>
